/* eslint-disable react/jsx-indent */
import React from 'react';

const Home = () => {
  return (
    <>
    <section className="home" id="home">
    <div className="container text-right">
   <p className="p-tag">  HELLO, I am Moyosore James.
     </p>
     {/* <h1 className = "title"> I am Moyosore James.</h1> */}
     <h4 className = "subtitle">
       A Software Developer
     </h4>
     <i class="fa-solid fa-bird"></i>
    </div>
      </section>
    </>
  );
};

export default Home;
